import { render, staticRenderFns } from "./MatchReadCPopup.vue?vue&type=template&id=e3dd2100&scoped=true"
import script from "./MatchReadCPopup.vue?vue&type=script&lang=js"
export * from "./MatchReadCPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3dd2100",
  null
  
)

export default component.exports